import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import UpgradeItemBlockData from 'app/Models/Content/UpgradeItemBlockData';
import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';
import TagName from 'app/Components/Shared/TagName';

const UpgradeItemBlock = ({data, context}: ComponentProps<UpgradeItemBlockData>) => (
  <a href={data.buttonLink.value} className='UpgradeItemBlock'>
    <div className='UpgradeItemBlock__title-and-image'>
      <TagName className='UpgradeItemBlock__title-and-image__title' tagName={data.titleHeadlineTag?.value} isTitle>
        {data.title.value}
      </TagName>
      <Image {...getImageProps(data.image, context)} />
    </div>

    <p className='UpgradeItemBlock__description'>{data.description.value}</p>

    <div className='UpgradeItemBlock__price-and-button'>
      {data.priceTitle.value && (
        <div className='UpgradeItemBlock__price-and-button__price-and-date'>
          <div className='UpgradeItemBlock__price-and-button__price-and-date__items'>
            <span className='UpgradeItemBlock__price-and-button__price-and-date__items__price'>{data.priceTitle.value}</span>
            <span className='UpgradeItemBlock__price-and-button__price-and-date__items__date'> לחודש</span>
          </div>
          {data.fullPrice?.value && (
            <span className='UpgradeItemBlock__price-and-button__price-and-date__full-price'>₪{data.fullPrice.value}</span>
          )}
        </div>
      )}

      {data.buttonLink.value && (
        <span className='UpgradeItemBlock__price-and-button__button'>{data.buttonLinkTitle.value || 'לפרטים'}</span>
      )}
    </div>
  </a>
);

export default UpgradeItemBlock;
